import { Component, Input } from '@angular/core';
import { EmployeeClockLog } from '../../models';
import * as moment from 'moment';

@Component({
    selector: 'employee-log',
    template: require('./employee.component.pug'),
    styles: [ require('./employee.component.scss')],
})
export class EmployeeLogComponent {
    @Input() employee: EmployeeClockLog;

    expanded = false;
    constructor() {
    }

    toggle(event: any) {
        this.expanded = !this.expanded;
    }

    get buttonColor(): string {
        return this.canExpand ? 'white' : 'gray';
    }

    get iconButton(): string {
        return this.expanded ? 'chevron-up' : 'chevron-down';
    }

    get canExpand(): Boolean  {
        return this.employee.clockLogs.length > 0;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/clock-in-out/shared/ui/employee/employee.component.ts